import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="overflow-hidden">
      <div className="grid grid-cols-1 md:grid-cols-2">
        <div className="relative bg-background-100 min-h-[320px] md:min-h-[420px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Dramatic%20theater%20stage%20with%20warm%20spotlight%2C%20empty%20stage%20with%20rich%20burgundy%20curtains%2C%20mysterious%20atmosphere%2C%20cinematic%20lighting%2C%20anticipation%20mood%2C%20editorial%20style%2C%20soft%20shadows%2C%20professional%20stage%20design&width=900&height=700&seq=cta-left-image&orientation=landscape"
            alt="吃瓜不打烊"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/20 to-transparent"></div>
          <div className="relative h-full flex flex-col justify-end p-8 md:p-12">
            <span className="text-xs font-medium text-white/60 uppercase tracking-wider">
              24/7 持续更新
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-white mt-2 leading-tight">
              深夜有瓜
              <br />
              白天有料
              <br />
              全年不打烊
            </h2>
          </div>
        </div>

        <div className="bg-background-50 min-h-[320px] md:min-h-[420px] flex items-center">
          <div className="p-8 md:p-12 w-full text-center">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 leading-tight">
              吃瓜就要
              <br />
              趁热吃
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mt-4 max-w-sm mx-auto">
              每天都有新鲜爆料，每时都有精彩内容。不管你是早起打卡还是深夜冲浪，这里总有你想看的瓜。
            </p>
            <Link
              to="/category/meiri-dasai"
              className="inline-flex items-center gap-2 mt-6 px-6 py-3 rounded-full bg-secondary-500 text-white text-sm font-medium hover:bg-secondary-600 transition-colors whitespace-nowrap"
            >
              进入每日大赛
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}